import React, { useCallback } from 'react';
import { Row } from 'react-table';

import { useSelector, useDispatch } from '../../../redux/hooks';
import { AlertDrawerActionTarget, AlertDrawerActionType, setTrailIds, setVisible } from '../../../redux/slices/alertsDrawer/alertsDrawer';
import Edit from '../../icons/Edit';
import Bell from '../../icons/Bell';
import { ActionsColumnValue } from '../types';
import * as styles from './styles/styles.module.scss';

type ActionsColumnProps = {
  row: Row;
  value: ActionsColumnValue;
};

const ActionsColumn = ({ row, value: { editUrl, alertUrl } }: ActionsColumnProps): JSX.Element => {
  const { checkbox: trailId } = row.values;
  const alertsDrawerEnabled = useSelector(state => state.enabledFeatures.alertsDrawer);
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    row.toggleRowSelected(true);
    dispatch(setTrailIds([trailId]));
    dispatch(setVisible({ visible: true, action: AlertDrawerActionType.ADD, target: AlertDrawerActionTarget.TRAILS }));
  }, [row, dispatch, trailId]);

  return (
    <div className={styles.actionIcons}>
      <a href={editUrl} target="_blank" rel="noopener noreferrer">
        <Edit title="Edit trail" />
      </a>
      {alertsDrawerEnabled && (
        <button onClick={onClick} type="button">
          <Bell title="Add alert" />
        </button>
      )}
      {!alertsDrawerEnabled && (
        <a href={alertUrl} target="_blank" rel="noopener noreferrer">
          <Bell title="Add alert" />
        </a>
      )}
    </div>
  );
};

export default ActionsColumn;
